<div class="sign-in-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="trinta-form ml-auto mr-auto">
                <div class="title">
                    <div class="logo-container">
                        <div class="opb-logo">
                            <img
                                src="/assets/images/logos/logotipo-fondo-claro.png"
                                alt="OPB Logistics"
                                class="opb-logo-image"
                            />
                        </div>
                    </div>
                </div>

                <form [formGroup]="authForm" (ngSubmit)="onSubmit()">
                    <div class="form-group">
                        <label class="label d-block fw-medium mb-10">
                            Correo Electrónico
                        </label>
                        <mat-form-field>
                            <mat-label>Ingresa tu correo electrónico</mat-label>
                            <input
                                matInput
                                type="email"
                                id="email"
                                formControlName="email"
                                inputmode="email"
                            />
                        </mat-form-field>
                        <div
                            class="error text-danger"
                            *ngIf="
                                authForm.get('email')!.hasError('required') &&
                                authForm.get('email')!.touched
                            "
                        >
                            El correo electrónico es requerido.
                        </div>
                        <div
                            class="error text-danger"
                            *ngIf="
                                authForm.get('email')!.hasError('email') &&
                                authForm.get('email')!.touched
                            "
                        >
                            Por favor ingresa un correo electrónico válido.
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="label d-block fw-medium mb-10">
                            Contraseña
                        </label>
                        <mat-form-field>
                            <mat-label>Ingresa tu contraseña</mat-label>
                            <input
                                matInput
                                [type]="hide ? 'password' : 'text'"
                                id="password"
                                formControlName="password"
                                inputmode="text"
                            />
                            <button
                                mat-icon-button
                                matSuffix
                                (click)="hide = !hide"
                                [attr.aria-label]="'Ocultar contraseña'"
                                [attr.aria-pressed]="hide"
                            >
                                <span class="material-symbols-outlined">
                                    {{ hide ? 'visibility_off' : 'visibility' }}
                                </span>
                            </button>
                        </mat-form-field>
                        <div
                            class="error text-danger"
                            *ngIf="
                                authForm
                                    .get('password')!
                                    .hasError('required') &&
                                authForm.get('password')!.touched
                            "
                        >
                            La contraseña es requerida.
                        </div>
                        <div
                            class="error text-danger"
                            *ngIf="
                                authForm
                                    .get('password')!
                                    .hasError('minlength') &&
                                authForm.get('password')!.touched
                            "
                        >
                            La contraseña debe tener al menos 8 caracteres.
                        </div>
                    </div>
                    <div
                        class="info d-flex justify-content-between align-items-center"
                    >
                        <mat-checkbox
                            color="primary"
                            formControlName="rememberMe"
                        >
                            Recordarme
                        </mat-checkbox>
                        <!-- TODO: Habilitar cuando se implemente la funcionalidad de recuperación de contraseña
                        <a routerLink="/authentication/forgot-password" class="d-inline-block text-primary">
                            ¿Olvidaste tu contraseña?
                        </a>
                        -->
                    </div>
                    <button
                        mat-button
                        type="submit"
                        [disabled]="authForm.invalid || isLoading"
                    >
                        <mat-spinner
                            *ngIf="isLoading"
                            diameter="20"
                            class="spinner"
                        ></mat-spinner>
                        <span *ngIf="!isLoading">Iniciar Sesión</span>
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
